import { Component, EventEmitter, Input, Output } from '@angular/core';

export const VIDEO_PROCESSING_TITLE = 'Video is still processing';
export const VIDEO_PROCESSING_MESSAGE =
  'Once it is processed, we will send you a mail.';

@Component({
  selector: 'app-video-processing-card',
  templateUrl: './video-processing-card.component.html',
  styleUrls: ['./video-processing-card.component.scss'],
})
export class VideoProcessingCardComponent {
  @Input() title = VIDEO_PROCESSING_TITLE;
  @Input() message = VIDEO_PROCESSING_MESSAGE;
  @Input() showRefresh = true;
  @Output() refresh = new EventEmitter<void>();

  onRefresh(): void {
    this.refresh.emit();
  }
}
